(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gojo-domain-landing"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var root=document.querySelector('[data-gojo-root]');
    if(!root||root.dataset.ready==='true')return;
    root.dataset.ready='true';
    document.body.classList.add('gojo-template');
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var audio=root.querySelector('[data-gojo-audio]');
    var gate=root.querySelector('[data-gojo-gate]');
    var gateVideo=root.querySelector('[data-gojo-gate-video]');
    var heroVideo=root.querySelector('[data-gojo-hero-video]');
    var handVideo=root.querySelector('[data-gojo-hand-video]');
    var soundButton=root.querySelector('[data-gojo-sound]');
    var soundLabel=root.querySelector('[data-gojo-sound-label]');
    var soundIcon=root.querySelector('[data-gojo-sound-icon]');
    var audioOn=false;
    function updateSound(){
      if(!soundButton)return;
      soundButton.setAttribute('aria-pressed',audioOn?'true':'false');
      soundLabel.textContent=audioOn?root.dataset.soundOnLabel:root.dataset.soundOffLabel;
      soundIcon.textContent=audioOn?'◗':'◖';
    }
    function playAudio(){
      if(!audio)return;
      var p=audio.play();
      if(p&&p.then)p.then(function(){audioOn=true;updateSound();}).catch(function(){audioOn=false;updateSound();});
    }
    function closeGate(silent){
      if(!gate)return;
      if(silent&&audio){audio.pause();audioOn=false;updateSound();}
      gate.classList.add('is-flashing');
      setTimeout(function(){gate.classList.add('is-closing');document.body.style.overflow='';if(heroVideo&&!reduced)heroVideo.play().catch(function(){});},250);
      setTimeout(function(){gate.hidden=true;},1100);
    }
    if(gate){
      document.body.style.overflow='hidden';
      var enter=gate.querySelector('[data-gojo-enter]');
      var skip=gate.querySelector('[data-gojo-skip]');
      enter.addEventListener('click',function(){
        gate.classList.add('is-playing');
        playAudio();
        if(reduced){closeGate(false);return;}
        if(gateVideo){
          gateVideo.currentTime=0;
          var p=gateVideo.play();
          if(p&&p.catch)p.catch(function(){closeGate(false);});
          gateVideo.addEventListener('ended',function(){closeGate(false);},{once:true});
          setTimeout(function(){if(!gate.hidden)closeGate(false);},10500);
        }else closeGate(false);
      });
      skip.addEventListener('click',function(){closeGate(true);});
    }else if(heroVideo&&!reduced){heroVideo.play().catch(function(){});}
    if(soundButton){soundButton.addEventListener('click',function(){
      if(!audio)return;
      if(audioOn){audio.pause();audioOn=false;updateSound();}else playAudio();
    });}
    if('IntersectionObserver' in window){
      var revealObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');revealObserver.unobserve(entry.target);}});},{threshold:.15});
      root.querySelectorAll('[data-gojo-reveal]').forEach(function(el){revealObserver.observe(el);});
      if(handVideo){
        var videoObserver=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting&&!reduced)handVideo.play().catch(function(){});else handVideo.pause();});},{threshold:.25});
        videoObserver.observe(handVideo);
      }
    }else root.querySelectorAll('[data-gojo-reveal]').forEach(function(el){el.classList.add('is-visible');});
    root.querySelectorAll('[data-gojo-product]').forEach(function(card){
      var main=card.querySelector('.gojo-product__image');
      card.querySelectorAll('[data-gojo-thumb]').forEach(function(thumb){thumb.addEventListener('click',function(){
        card.querySelectorAll('[data-gojo-thumb]').forEach(function(item){item.classList.remove('is-active');});
        thumb.classList.add('is-active');
        if(main){main.src=thumb.dataset.src;main.removeAttribute('srcset');}
      });});
      var select=card.querySelector('[data-gojo-variant]');
      var price=card.querySelector('[data-gojo-price]');
      var add=card.querySelector('[data-gojo-add]');
      var label=card.querySelector('[data-gojo-add-label]');
      if(select)select.addEventListener('change',function(){
        var option=select.options[select.selectedIndex];
        if(price)price.textContent=option.dataset.price;
        var available=option.dataset.available==='true';
        if(add)add.disabled=!available;
        if(label)label.textContent=available?root.dataset.addLabel:root.dataset.soldOutLabel;
      });
      var form=card.querySelector('form');
      if(form)form.addEventListener('submit',function(event){
        if(!event.submitter||!event.submitter.hasAttribute('data-gojo-add'))return;
        event.preventDefault();
        if(!add||add.disabled)return;
        add.disabled=true;
        fetch(root.dataset.cartAddUrl+'.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)})
          .then(function(response){if(!response.ok)throw new Error('cart');return response.json();})
          .then(function(){showToast(root.dataset.addedLabel);if(label)label.textContent=root.dataset.addedLabel;setTimeout(function(){add.disabled=false;if(label)label.textContent=root.dataset.addLabel;},1800);})
          .catch(function(){showToast(root.dataset.errorLabel);add.disabled=false;});
      });
    });
    var productTrack=root.querySelector('[data-gojo-products-track]');
    function scrollProducts(direction){
      if(!productTrack)return;
      var card=productTrack.querySelector('.gojo-product');
      if(!card)return;
      var styles=getComputedStyle(productTrack);
      var gap=parseFloat(styles.gap||styles.columnGap||'0')||0;
      productTrack.scrollBy({left:direction*(card.offsetWidth+gap),behavior:'smooth'});
    }
    var productPrevious=root.querySelector('[data-gojo-products-prev]');
    var productNext=root.querySelector('[data-gojo-products-next]');
    if(productPrevious)productPrevious.addEventListener('click',function(){scrollProducts(-1);});
    if(productNext)productNext.addEventListener('click',function(){scrollProducts(1);});
    var toast=root.querySelector('[data-gojo-toast]');
    var toastTimer;
    function showToast(message){if(!toast)return;clearTimeout(toastTimer);toast.textContent=message;toast.classList.add('is-visible');toastTimer=setTimeout(function(){toast.classList.remove('is-visible');},2200);}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsw-collection-toolbar-top"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const place = (root) => {
      if (!root) return;
      const bar = root.querySelector('.gswv-mobile-actions');
      const head = root.querySelector('.gswv-chead');
      if (!bar || !head) return;
      if (bar.previousElementSibling === head) return;
      head.after(bar);
    };

    const run = () => {
      document.querySelectorAll('[data-gswv-collection]').forEach(place);
    };

    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        run();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    if (!window.gswTopbarObserver) {
      window.gswTopbarObserver = new MutationObserver(schedule);
      window.gswTopbarObserver.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('shopify:section:load', schedule);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsw-new-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gsw-new-bundle')) {
    customElements.define('gsw-new-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.grid = this.querySelector('[data-grid]');
        this.status = this.querySelector('[data-status]');
        this.submit = this.querySelector('[data-submit]');
        this.cartLink = this.querySelector('[data-cart-link]');
        this.root = this.dataset.root.replace(/\/?$/, '/');
        this.grid.addEventListener('change', event => this.change(event));
        this.submit.addEventListener('click', () => this.add());
        this.load();
      }
      async load() {
        try {
          const url = new URL(this.root + 'collections/all', location.origin);
          url.searchParams.set('sort_by', 'created-descending');
          url.searchParams.set('section_id', this.dataset.section);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error();
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = doc.querySelector('gsw-new-bundle template[data-products]');
          if (!source) throw new Error();
          const cards = Array.from(source.content.querySelectorAll('[data-product]')).filter(card => card.dataset.product !== this.dataset.current).slice(0, Number(this.dataset.limit));
          this.grid.replaceChildren(...cards.map(card => document.importNode(card, true)));
          this.status.textContent = cards.length ? '' : this.dataset.empty;
          this.update();
        } catch (error) {
          this.status.textContent = this.dataset.error;
        } finally {
          this.grid.setAttribute('aria-busy', 'false');
        }
      }
      change(event) {
        const card = event.target.closest('[data-product]');
        if (!card || this.busy) return;
        const select = card.querySelector('[data-variant]');
        const checkbox = card.querySelector('[data-select]');
        if (event.target === select) {
          checkbox.disabled = !select.value;
          checkbox.checked = !!select.value;
          if (select.value) card.querySelector('[data-price]').textContent = select.selectedOptions[0].dataset.money;
        }
        this.status.textContent = '';
        this.cartLink.hidden = true;
        this.update();
      }
      selected() {
        return Array.from(this.grid.querySelectorAll('[data-product]')).filter(card => card.querySelector('[data-select]').checked && card.querySelector('[data-variant]').value);
      }
      update() {
        const cards = this.selected();
        const total = cards.reduce((sum, card) => sum + Number(card.querySelector('[data-variant]').selectedOptions[0].dataset.price), 0);
        this.querySelector('[data-count]').textContent = cards.length;
        this.querySelector('[data-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: this.dataset.currency || 'INR' }).format(total / 100);
        const thumbs = this.querySelector('[data-thumbs]');
        thumbs.replaceChildren();
        for (const card of this.grid.querySelectorAll('[data-product]')) card.classList.toggle('is-selected', cards.includes(card));
        for (const card of cards) {
          const photo = card.querySelector('img');
          if (photo) { const thumb = photo.cloneNode(); thumb.alt = ''; thumb.removeAttribute('sizes'); thumb.removeAttribute('srcset'); thumbs.append(thumb); }
        }
        this.submit.disabled = this.busy || !cards.length;
      }
      async add() {
        if (this.busy) return;
        const cards = this.selected();
        if (!cards.length) return;
        const items = cards.map(card => ({ id: Number(card.querySelector('[data-variant]').value), quantity: 1 }));
        this.busy = true;
        this.grid.querySelectorAll('input,select').forEach(el => el.disabled = true);
        this.submit.disabled = true;
        this.submit.textContent = this.dataset.adding;
        this.status.textContent = '';
        let sent = false;
        let success = false;
        try {
          sent = true;
          const response = await fetch(this.root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const result = await response.json();
          if (!response.ok || result.status) {
            this.status.textContent = typeof result.description === 'string' ? result.description : this.dataset.uncertain;
            this.cartLink.hidden = false;
            return;
          }
          success = true;
          this.status.textContent = this.dataset.added;
          location.assign(this.dataset.cart);
        } catch (error) {
          this.status.textContent = sent ? this.dataset.uncertain : this.dataset.error;
          this.cartLink.hidden = false;
        } finally {
          if (!success) {
            this.busy = false;
            this.grid.querySelectorAll('[data-variant]').forEach(el => el.disabled = false);
            this.grid.querySelectorAll('[data-product]').forEach(card => { card.querySelector('[data-select]').disabled = !card.querySelector('[data-variant]').value; card.querySelector('[data-select]').checked = false; });
            this.submit.textContent = this.dataset.add;
            this.update();
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gsw-v-collection"]) return;
  try {
    
  (() => {
    let filterRequestController = null;

    const formUrl = (form) => {
      const data = new FormData(form);
      const params = new URLSearchParams();

      data.forEach((value, key) => {
        if (String(value).trim() !== '') params.append(key, value);
      });

      const query = params.toString();
      return query ? `${form.action}?${query}` : form.action;
    };

    const navigate = async (root, url, pushState = true) => {
      if (!root) return;

      if (filterRequestController) filterRequestController.abort();
      filterRequestController = new AbortController();
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: filterRequestController.signal
        });

        if (!response.ok) throw new Error('Collection request failed');

        const html = await response.text();
        const page = new DOMParser().parseFromString(html, 'text/html');
        const nextRoot = page.querySelector('[data-gswv-collection]');

        if (!nextRoot) throw new Error('Collection markup was not found');

        const replace = () => {
          if (typeof root.gswvCleanup === 'function') root.gswvCleanup();
          root.replaceWith(nextRoot);
          init(nextRoot);
        };

        document.body.classList.remove('gswv-sheet-open');
        if (document.startViewTransition) document.startViewTransition(replace);
        else replace();

        if (page.title) document.title = page.title;
        if (pushState) window.history.pushState({}, '', url);
      } catch (error) {
        if (error.name === 'AbortError') return;
        window.location.assign(url);
      } finally {
        root.classList.remove('is-loading');
        root.removeAttribute('aria-busy');
      }
    };

    const init = (root) => {
      if (!root || root.dataset.gswvReady === 'true') return;
      root.dataset.gswvReady = 'true';

      const sortSelect = root.querySelector('[data-gswv-sort-select]');
      if (sortSelect) {
        sortSelect.addEventListener('change', () => sortSelect.form.requestSubmit());
      }

      root.querySelectorAll('form').forEach((form) => {
        form.addEventListener('submit', (event) => {
          event.preventDefault();
          const dialog = form.closest('dialog');
          if (dialog && dialog.open) dialog.close();
          navigate(root, formUrl(form));
        });
      });

      const desktopFilterForm = root.querySelector('.gswv-filter-form');
      if (desktopFilterForm) {
        let applyTimer = null;
        desktopFilterForm.addEventListener('change', () => {
          window.clearTimeout(applyTimer);
          applyTimer = window.setTimeout(() => desktopFilterForm.requestSubmit(), 180);
        });
      }

      root.addEventListener('click', (event) => {
        const link = event.target.closest(
          '.gswv-active-chip, .gswv-clear-all, .gswv-sidebar-heading a, .gswv-filter-footer a'
        );
        if (!link || !root.contains(link)) return;
        event.preventDefault();
        navigate(root, link.href);
      });

      root.querySelectorAll('[data-gswv-toggle-values]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
        button.addEventListener('click', () => {
          const group = button.closest('.gswv-filter-group');
          const values = group ? group.querySelectorAll('.gswv-value-overflow') : [];
          const expanded = button.getAttribute('aria-expanded') === 'true';

          values.forEach((value) => {
            value.hidden = expanded;
          });
          button.setAttribute('aria-expanded', String(!expanded));
          button.textContent = expanded ? button.dataset.showMore : button.dataset.showLess;
        });
      });

      root.querySelectorAll('[data-gswv-open]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = root.querySelector(`[data-gswv-dialog="${button.dataset.gswvOpen}"]`);
          if (!dialog) return;
          document.body.classList.add('gswv-sheet-open');
          dialog.showModal();
        });
      });

      root.querySelectorAll('[data-gswv-dialog]').forEach((dialog) => {
        const closeDialog = () => {
          dialog.close();
          document.body.classList.remove('gswv-sheet-open');
        };

        dialog.querySelectorAll('[data-gswv-close]').forEach((button) => {
          button.addEventListener('click', closeDialog);
        });

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });

        dialog.addEventListener('close', () => {
          document.body.classList.remove('gswv-sheet-open');
        });
      });

      const grid = root.querySelector('[data-gswv-grid]');
      const sentinel = root.querySelector('[data-gswv-more]');
      const spinner = root.querySelector('[data-gswv-spin]');
      const endMessage = root.querySelector('[data-gswv-end]');
      const fallback = root.querySelector('[data-gswv-fallback]');

      if (!grid || !sentinel) return;
      if (fallback) fallback.hidden = true;

      let next = sentinel.dataset.next || '';
      let busy = false;
      let observer = null;
      let pagesSeen = 1;

      root.gswvCleanup = () => {
        if (observer) observer.disconnect();
        window.removeEventListener('scroll', nudge);
      };

      const finish = () => {
        next = '';
        if (observer) observer.disconnect();
        if (spinner) spinner.classList.remove('on');
        if (endMessage && pagesSeen > 1) endMessage.classList.add('on');
      };

      const nudge = () => {
        if (!next || busy) return;
        if (sentinel.getBoundingClientRect().top < window.innerHeight + 700) load();
      };

      const load = () => {
        if (busy || !next) return;
        busy = true;
        if (spinner) spinner.classList.add('on');

        fetch(next, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error('Collection page request failed');
            return response.text();
          })
          .then((html) => {
            const page = new DOMParser().parseFromString(html, 'text/html');
            const nextRoot = page.querySelector('[data-gswv-collection]');
            const nextGrid = nextRoot && nextRoot.querySelector('[data-gswv-grid]');
            const nextSentinel = nextRoot && nextRoot.querySelector('[data-gswv-more]');

            if (nextGrid) {
              while (nextGrid.firstElementChild) grid.appendChild(nextGrid.firstElementChild);
            }

            next = nextSentinel ? nextSentinel.dataset.next || '' : '';
            pagesSeen += 1;
            busy = false;
            if (spinner) spinner.classList.remove('on');

            if (!next) finish();
            else window.setTimeout(nudge, 60);
          })
          .catch(() => {
            busy = false;
            if (spinner) spinner.classList.remove('on');
            if (fallback) fallback.hidden = false;
          });
      };

      if (!next) return;

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(
          (entries) => {
            if (entries[0] && entries[0].isIntersecting) load();
          },
          { rootMargin: '700px 0px' }
        );
        observer.observe(sentinel);
      } else {
        window.addEventListener('scroll', nudge, { passive: true });
        nudge();
      }
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-gswv-collection]').forEach(init);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));

    if (!window.gswvPopstateBound) {
      window.gswvPopstateBound = true;
      window.addEventListener('popstate', () => {
        const root = document.querySelector('[data-gswv-collection]');
        navigate(root, window.location.href, false);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["itachi-product-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-itachi-landing]:not([data-itx-ready])');

    roots.forEach((root) => {
      root.dataset.itxReady = 'true';
      const $ = (selector, scope = root) => scope.querySelector(selector);
      const $$ = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));
      const intro = $('[data-itx-intro]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const onceKey = `itx-awakening-${root.dataset.sectionId}`;
      let muted = false;
      let audioContext = null;
      let introTimers = [];

      const clearIntroTimers = () => {
        introTimers.forEach(window.clearTimeout);
        introTimers = [];
      };

      const setScrollLock = (locked) => {
        document.documentElement.style.overflow = locked ? 'hidden' : '';
      };

      const closeIntro = (remember = true) => {
        if (!intro) return;
        clearIntroTimers();
        intro.classList.add('is-gone');
        setScrollLock(false);
        if (remember && root.dataset.introOnce === 'true') {
          try { window.sessionStorage.setItem(onceKey, 'seen'); } catch (error) {}
        }
        introTimers.push(window.setTimeout(() => { intro.hidden = true; }, 950));
      };

      const tone = (context, destination, options) => {
        const oscillator = context.createOscillator();
        const gain = context.createGain();
        oscillator.type = options.type || 'sine';
        oscillator.frequency.setValueAtTime(options.from, options.at);
        if (options.to) oscillator.frequency.exponentialRampToValueAtTime(options.to, options.at + options.duration);
        gain.gain.setValueAtTime(0.0001, options.at);
        gain.gain.exponentialRampToValueAtTime(options.volume, options.at + Math.min(.05, options.duration / 4));
        gain.gain.exponentialRampToValueAtTime(0.0001, options.at + options.duration);
        oscillator.connect(gain).connect(destination);
        oscillator.start(options.at);
        oscillator.stop(options.at + options.duration + .02);
      };

      const noiseBurst = (context, destination, at, duration, volume, frequency) => {
        const buffer = context.createBuffer(1, Math.ceil(context.sampleRate * duration), context.sampleRate);
        const data = buffer.getChannelData(0);
        for (let i = 0; i < data.length; i += 1) data[i] = (Math.random() * 2 - 1) * (1 - i / data.length);
        const source = context.createBufferSource();
        const filter = context.createBiquadFilter();
        const gain = context.createGain();
        source.buffer = buffer;
        filter.type = 'lowpass';
        filter.frequency.setValueAtTime(frequency, at);
        filter.frequency.exponentialRampToValueAtTime(Math.max(70, frequency / 4), at + duration);
        gain.gain.setValueAtTime(volume, at);
        gain.gain.exponentialRampToValueAtTime(.0001, at + duration);
        source.connect(filter).connect(gain).connect(destination);
        source.start(at);
      };

      const playAwakeningSound = () => {
        if (muted || reducedMotion) return;
        const AudioCtor = window.AudioContext || window.webkitAudioContext;
        if (!AudioCtor) return;
        audioContext = audioContext || new AudioCtor();
        if (audioContext.state === 'suspended') audioContext.resume();
        const master = audioContext.createGain();
        const compressor = audioContext.createDynamicsCompressor();
        master.gain.setValueAtTime(.5, audioContext.currentTime);
        master.connect(compressor).connect(audioContext.destination);
        const now = audioContext.currentTime + .03;

        tone(audioContext, master, { from: 42, to: 32, at: now, duration: 4.4, volume: .22, type: 'sine' });
        tone(audioContext, master, { from: 68, to: 46, at: now, duration: 4.2, volume: .1, type: 'triangle' });
        [0, .65, 1.32].forEach((offset) => {
          tone(audioContext, master, { from: 92, to: 55, at: now + offset, duration: .22, volume: .32, type: 'sine' });
          tone(audioContext, master, { from: 70, to: 45, at: now + offset + .18, duration: .3, volume: .25, type: 'sine' });
        });
        tone(audioContext, master, { from: 110, to: 820, at: now + 1.25, duration: 2.35, volume: .13, type: 'sawtooth' });
        noiseBurst(audioContext, master, now + 1.2, 2.7, .17, 2100);
        tone(audioContext, master, { from: 54, to: 27, at: now + 3.75, duration: 1.15, volume: .56, type: 'sine' });
        noiseBurst(audioContext, master, now + 3.74, 1.2, .5, 1400);
      };

      const awaken = () => {
        if (!intro || intro.classList.contains('is-awakening')) return;
        intro.classList.add('is-awakening');
        playAwakeningSound();
        const flashAt = reducedMotion ? 250 : 3750;
        const closeAt = reducedMotion ? 650 : 4900;
        introTimers.push(window.setTimeout(() => intro.classList.add('is-flashing'), flashAt));
        introTimers.push(window.setTimeout(() => closeIntro(true), closeAt));
      };

      if (intro) {
        let hasSeen = false;
        try { hasSeen = window.sessionStorage.getItem(onceKey) === 'seen'; } catch (error) {}
        if ((root.dataset.introOnce === 'true' && hasSeen) || reducedMotion) {
          closeIntro(false);
        } else {
          setScrollLock(true);
        }
        $('[data-itx-awaken]')?.addEventListener('click', awaken);
        $('[data-itx-skip]')?.addEventListener('click', () => closeIntro(true));
        $('[data-itx-mute]')?.addEventListener('click', (event) => {
          muted = !muted;
          event.currentTarget.setAttribute('aria-pressed', String(muted));
          event.currentTarget.setAttribute('aria-label', muted ? 'Enable awakening sound' : 'Mute awakening sound');
          if (muted && audioContext) audioContext.suspend();
          if (!muted && audioContext) audioContext.resume();
        });
      }

      $('[data-itx-replay]')?.addEventListener('click', () => {
        if (!intro) return;
        clearIntroTimers();
        intro.hidden = false;
        intro.classList.remove('is-gone', 'is-awakening', 'is-flashing');
        setScrollLock(true);
        requestAnimationFrame(() => $('[data-itx-awaken]')?.focus());
      });

      const mainMedia = $('[data-itx-main-media]');
      $$('[data-itx-media]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!mainMedia || button.classList.contains('is-active')) return;
          mainMedia.classList.add('is-changing');
          window.setTimeout(() => {
            mainMedia.src = button.dataset.mediaSrc;
            mainMedia.srcset = button.dataset.mediaSrcset;
            mainMedia.alt = button.dataset.mediaAlt;
            mainMedia.classList.remove('is-changing');
          }, 180);
          $$('[data-itx-media]').forEach((item) => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        });
      });

      const variantsNode = $('[data-itx-variants]');
      const form = $('[data-itx-form]');
      if (variantsNode && form) {
        const variants = JSON.parse(variantsNode.textContent);
        const optionGroups = $$('[data-itx-option]');
        const variantInput = $('[data-itx-variant-id]');
        const price = $('[data-itx-price]');
        const mobilePrice = $('[data-itx-mobile-price]');
        const compare = $('[data-itx-compare]');
        const stock = $('[data-itx-stock]');
        const addButton = $('[data-itx-add]');
        const mobileAdd = $('[data-itx-mobile-add]');
        const addLabel = $('[data-itx-add-label]');

        const formatMoney = (cents) => {
          if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || undefined);
          const currency = window.Shopify?.currency?.active || 'INR';
          return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency }).format(cents / 100);
        };

        const updateVariant = () => {
          const selected = optionGroups.map((group) => $('input:checked', group)?.value);
          const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
          if (!variant) {
            addButton.disabled = true;
            if (mobileAdd) mobileAdd.disabled = true;
            addLabel.textContent = 'Unavailable';
            return;
          }
          variantInput.value = variant.id;
          price.textContent = formatMoney(variant.price);
          if (mobilePrice) mobilePrice.textContent = formatMoney(variant.price);
          const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
          compare.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
          compare.classList.toggle('is-hidden', !hasCompare);
          stock.classList.toggle('is-sold-out', !variant.available);
          stock.lastChild.textContent = variant.available ? ' In stock · ready to ship' : ' Currently sold out';
          addButton.disabled = !variant.available;
          if (mobileAdd) mobileAdd.disabled = !variant.available;
          addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
          if (variant.featured_media) {
            const mediaButton = $(`[data-itx-media][data-media-id="${variant.featured_media.id}"]`);
            mediaButton?.click();
          }
        };

        optionGroups.forEach((group) => group.addEventListener('change', updateVariant));
        mobileAdd?.addEventListener('click', () => addButton.click());

        const purchase = $('[id^="ItachiPurchase-"]');
        if (purchase && mobileAdd) {
          const observer = new IntersectionObserver(([entry]) => {
            $('[data-itx-mobile-buy]')?.classList.toggle('is-visible', !entry.isIntersecting && window.scrollY > 250);
          }, { threshold: .08 });
          observer.observe(purchase);
        }
      }

      const modal = $('[data-itx-size-modal]');
      const openSize = () => {
        if (!modal) return;
        modal.hidden = false;
        setScrollLock(true);
        $('[data-itx-size-close]', modal)?.focus();
      };
      const closeSize = () => {
        if (!modal) return;
        modal.hidden = true;
        setScrollLock(false);
        $('[data-itx-size-open]')?.focus();
      };
      $('[data-itx-size-open]')?.addEventListener('click', openSize);
      $$('[data-itx-size-close]').forEach((button) => button.addEventListener('click', closeSize));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal && !modal.hidden) closeSize();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
